module.exports = __webpack_public_path__ + "img/scurve-esd-min.93a9ea61.png";